import React from 'react';
import './Login.css';
import { Link, useLocation, useHistory } from 'react-router-dom';
import useAuth from '../../hooks/UseAuth';

const Login = () => {
    const {signInUsingGoogle} = useAuth();
    const location = useLocation();
    const history = useHistory();
    const redirect_uri = location.state?.from || '/home'

    const handleGoogleLogin = () =>{
        signInUsingGoogle()
        .then(result =>{
            history.push(redirect_uri)
        })
    }
    
    return (
        <div className="login-form mt-5 shadow-lg">
            <h1 className="fs-1">Please login</h1>
            <button className="button my-4" onClick={handleGoogleLogin}><i className="fab fa-google"></i> Google SingIn</button>
            <br />
            <Link to="/register" className="text-dark fs-5 text-decoration-none mt-5">New to Tourism? <span className="text-primary text-decoration-underline">Sign Up</span> </Link>
        </div>
    );
};

export default Login;